import React from "react";
import { TranslationFilters } from "./types";

interface FilterBarProps {
  filters: TranslationFilters;
  setFilters: React.Dispatch<React.SetStateAction<TranslationFilters>>;
}

const FilterBar: React.FC<FilterBarProps> = ({ filters, setFilters }) => {
  const handleFilterChange = (filterType: keyof TranslationFilters) => {
    setFilters((prev) => ({
      ...prev,
      [filterType]: !prev[filterType],
    }));
  };

  return (
    <div className="mb-6 bg-white p-4 rounded-lg shadow-sm border border-gray-200">
      <div className="flex flex-col sm:flex-row items-start sm:items-center">
        <span className="font-medium text-gray-700 mr-4 mb-2 sm:mb-0">
          Filter:
        </span>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => handleFilterChange("showMissing")}
            className={`px-3 py-1 rounded-md text-sm transition-colors ${
              filters.showMissing
                ? "bg-red-100 text-red-800 border border-red-300"
                : "bg-gray-100 text-gray-700 border border-gray-300 hover:bg-gray-200"
            }`}
          >
            Missing Translations
          </button>

          <button
            onClick={() => handleFilterChange("showEmpty")}
            className={`px-3 py-1 rounded-md text-sm transition-colors ${
              filters.showEmpty
                ? "bg-amber-100 text-amber-800 border border-amber-300"
                : "bg-gray-100 text-gray-700 border border-gray-300 hover:bg-gray-200"
            }`}
          >
            Empty Values
          </button>

          <button
            onClick={() => handleFilterChange("showIdentical")}
            className={`px-3 py-1 rounded-md text-sm transition-colors ${
              filters.showIdentical
                ? "bg-blue-100 text-blue-800 border border-blue-300"
                : "bg-gray-100 text-gray-700 border border-gray-300 hover:bg-gray-200"
            }`}
          >
            Identical to Master
          </button>

          <button
            onClick={() => handleFilterChange("showNonMaster")}
            className={`px-3 py-1 rounded-md text-sm transition-colors ${
              filters.showNonMaster
                ? "bg-purple-100 text-purple-800 border border-purple-300"
                : "bg-gray-100 text-gray-700 border border-gray-300 hover:bg-gray-200"
            }`}
          >
            Not in Master
          </button>

          {(filters.showMissing ||
            filters.showEmpty ||
            filters.showIdentical ||
            filters.showNonMaster) && (
            <button
              onClick={() =>
                setFilters({
                  showMissing: false,
                  showEmpty: false,
                  showIdentical: false,
                  showNonMaster: false,
                })
              }
              className="px-3 py-1 rounded-md text-sm bg-gray-200 text-gray-700 border border-gray-300 hover:bg-gray-300"
            >
              Clear Filters
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
